module.exports = __webpack_public_path__ + "img/Twitter.35d9a342.png";